import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing, $done } from 'services/activity/action';

export const MODULE = 'Shipment';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, 'Get', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/${id}`, payload)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $update = ActionCreator.Async(MODULE, 'Update', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/delivery/${id}`, payload)
      .then((response) => {
        dispatch($update.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $updatePartial = ActionCreator.Async(
  MODULE,
  'Update.Partial',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/delivery/${id}/partial`, payload)
        .then((response) => {
          dispatch($updatePartial.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $delete = ActionCreator.Async(MODULE, 'Delete', (id) => {
  return async (dispatch) => {
    dispatch($processing($delete.OPERATION));

    return await Rest.DELETE(`${API_URL}/tms/delivery/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($delete.OPERATION)));
  };
});

export const $publish = ActionCreator.Async(
  MODULE,
  'Publish',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/delivery/${id}/publish`, payload)
        .then((response) => {
          dispatch($publish.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $void = ActionCreator.Async(MODULE, 'Void', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/delivery/${id}/void`, payload)
      .then((response) => {
        dispatch($void.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $paid = ActionCreator.Async(MODULE, 'Paid', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/delivery/${id}/paid`, payload)
      .then((response) => {
        dispatch($paid.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $getImage = ActionCreator.Async(
  MODULE,
  'Get.Image',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($processing($getImage.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/delivery/shipment/image/${id}/shipment`,
        payload
      )
        .then((response) => {
          dispatch($getImage.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getImage.OPERATION)));
    };
  }
);

export const $getImageByOrder = ActionCreator.Async(
  MODULE,
  'Get.ImageByOrder',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($processing($getImageByOrder.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/delivery/shipment/image/${id}/order`,
        payload
      )
        .then((response) => {
          dispatch($getImageByOrder.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getImageByOrder.OPERATION)));
    };
  }
);

export const $deleteImage = ActionCreator.Async(
  MODULE,
  'Delete.Image',
  (id) => {
    return async (dispatch) => {
      dispatch($processing($deleteImage.OPERATION));

      return await Rest.DELETE(`${API_URL}/tms/delivery/shipment/image/${id}`)
        .then((response) => {
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($deleteImage.OPERATION)));
    };
  }
);

export const $deleteImageByURL = ActionCreator.Async(
  MODULE,
  'Delete.ImageByURL',
  (url) => {
    return async (dispatch) => {
      dispatch($processing($deleteImageByURL.OPERATION));

      return await Rest.DELETE(`${API_URL}/tms/delivery/shipment/image/byurl`, {url})
        .then((response) => {
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($deleteImageByURL.OPERATION)));
    };
  }
);

export const $upload = ActionCreator.Async(
  MODULE,
  'Image.Upload',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/tms/delivery/shipment/image`, payload)
        .then((response) => {
          dispatch($upload.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);